/** Base workfolio URL (path or absolute), e.g. /workfolio.php or full URL to workfolio.php */
export function listDeptsUrl(endpoint: string): string {
  const sep = endpoint.includes('?') ? '&' : '?';
  return `${endpoint}${sep}listDepts`;
}
